import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const IconBool = ({value, classAdd=""}) => {

    return (
        value ? <FontAwesomeIcon icon="check" className={`text-blue ${classAdd}`}/>
            : <FontAwesomeIcon icon="square" className={`text-light ${classAdd}`}/>
    )
}
export default IconBool